import { render, staticRenderFns } from "./ForthingDetail.vue?vue&type=template&id=3e322101&scoped=true&"
import script from "./ForthingDetail.vue?vue&type=script&lang=js&"
export * from "./ForthingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ForthingDetail.vue?vue&type=style&index=0&id=3e322101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e322101",
  null
  
)

export default component.exports